var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBarChartBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_15_659)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.5 11.5V3H0.5V12C0.5 12.1326 0.552678 12.2598 0.646447 12.3536C0.740215 12.4473 0.867392 12.5 1 12.5H12.5V11.5H1.5Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 7.5C5 7.36739 4.94732 7.24021 4.85355 7.14645C4.75979 7.05268 4.63261 7 4.5 7H3C2.86739 7 2.74021 7.05268 2.64645 7.14645C2.55268 7.24021 2.5 7.36739 2.5 7.5V11H5V7.5Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 5.5C8.5 5.36739 8.44732 5.24021 8.35355 5.14645C8.25979 5.05268 8.13261 5 8 5H6.5C6.36739 5 6.24021 5.05268 6.14645 5.14645C6.05268 5.24021 6 5.36739 6 5.5V11H8.5V5.5Z",
    fill: "#155EEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.5C12 3.36739 11.9473 3.24021 11.8536 3.14645C11.7598 3.05268 11.6326 3 11.5 3H10C9.86739 3 9.74021 3.05268 9.64645 3.14645C9.55268 3.24021 9.5 3.36739 9.5 3.5V11H12V3.5Z",
    fill: "#155EEF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_15_659"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBarChartBlue);
export default __webpack_public_path__ + "static/media/bar-chart-blue.1ed731b9a7d831ccff5e08e6d9620f46.svg";
export { ForwardRef as ReactComponent };